import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserEmergencyContactForm } from "Bands/components";
import { createUserEmergencyContact, dispatchGetUserEmergencyContacts } from "Bands/state";
import { IUserEmergencyContactPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Contact } from "shared/assets/icons";

const { userEmergencyContact: contactCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserEmergencyContactModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: contactCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserEmergencyContactPatchData) => {
    dispatch(createUserEmergencyContact(data));
  };

  const handleSuccess = () => {
    dispatchGetUserEmergencyContacts(dispatch);
  };

  return (
    <UserEntityModal
      title={contactCopy.create.title}
      icon={Contact}
      action={USER_ACTIONS.createUserEmergencyContact}
      buttons={buttons}
      successMessage={contactCopy.messages.created}
      Component={UserEmergencyContactForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
